import { Component, OnInit } from '@angular/core';
import * as momentZone from 'moment-timezone';
import { Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { Input } from '@angular/core';
import * as moment from 'moment-timezone';
import { ViewChild } from '@angular/core';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';

export class TZone {
    name: string;
    nameValue: string;
    timeValue: string;
    group: string;
    abbr: string;
}

@Component({
    selector: 'app-timezone-converter',
    templateUrl: './timezone-converter.component.html',
    styleUrls: ['./timezone-converter.component.scss']
})

export class TimezoneConverterComponent implements OnInit {

    constructor() {
    }

    timeZones: Array<TZone>;
    timezone: any;

    @Input()
    greeceTime: string;

    @Output()
    selectedTimezone: EventEmitter<string> = new EventEmitter<string>();

    @ViewChild("p")
    popOver: NgbPopover;

    previewDate: string;

    yourTime: string = 'Convert to local';

    ngOnInit(): void {
        this.timeZones = momentZone.tz.names().map((zone: string) => this.formatZone(zone));
        this.timezone = this.formatZone(momentZone.tz.guess(true));
        const countDownDate = moment(this.greeceTime).tz('Europe/Athens');
        this.yourTime = this.timezone.nameValue + ': ' + countDownDate.format("DD/MM/YYYY H:m:s");
        this.previewDate = countDownDate.format("DD/MM/YYYY H:m:s");
    }

    onSelectChange() {
        const countDownDate = moment(this.greeceTime).tz(this.timezone.nameValue);
        this.yourTime = this.timezone.nameValue + ': ' + countDownDate.format("DD/MM/YYYY H:m:s");
        this.popOver.close();
    }

    /**
     * Make TZone object from simple string.
     * @link ngOnInit
     */
    private formatZone(zone: string): TZone {
        const utc: string = momentZone.tz(zone).format('Z');
        const abbr: string = momentZone.tz(zone).zoneAbbr();
        return {
            name: `${zone} (${utc})`,
            nameValue: zone,
            timeValue: utc,
            group: zone.split('/', 1)[0],
            abbr: abbr
        };
    }

}
